import { gtmSendEvent } from "@wojo/analytics";
import { useIsExecutingMutation } from "@wojo/apollo";
import { useI18n } from "@wojo/localization";
import { Button } from "@wojo/ui";
import React from "react";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import { useTrackEvent } from "@optimizely/react-sdk";

export const QuoteSubmit: React.FC = () => {
    const { navigationLoading, draftQuote } = useTripBuilderQuote();
    const { productPage } = useI18n("productPage");
    const isExecutingMutation = useIsExecutingMutation();
    const [optimizelyTrack, optimizelyClientReady] = useTrackEvent();

    return (
        <Button
            data-testid="quote-submit"
            loading={isExecutingMutation || navigationLoading}
            disabled={isExecutingMutation}
            onClick={() => {
                gtmSendEvent({
                    event: "track",
                    ga4Tracking: {
                        ga4_object: "TRIP_BUILDER",
                        ga4_action: "BOOK_NOW",
                    },
                });
                gtmSendEvent({
                    event: "track",
                    ga4Tracking: {
                        ga4_object: "QUOTE",
                        ga4_action: "CREATED",
                        quoteId: draftQuote?.order._id || "",
                    },
                });
                if (optimizelyClientReady) {
                    optimizelyTrack("trip_builder_book_now");
                }
            }}
        >
            {process.env.NEXT_PUBLIC_UNRELEASED_FEATURE_SAVED_QUOTES === "true"
                ? productPage.tripBuilder.quote.submitLabel.l()
                : "Book now"}
        </Button>
    );
};
